var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-sider"},[_c('div',{staticClass:"c-add-comp"},[_c('Moduler',{attrs:{"title":"添加组件"}},[_c('Clock',{attrs:{"data":_vm.data},on:{"on-add":_vm.addSider},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }